<template>
    <component :is="template">
        <div>
            <v-card tile elevation="0" class="overflow-auto">
                <div>
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">도서 구매내역</h2>
                    </div>

                    <div>
                        <div class="mb-30px mb-md-40px">
                            <v-layout>
                                <v-btn :color="filter.code == 'ebook' ? 'primary' : 'grey'" :outlined="filter.code == 'ebook' ? false : true" x-large tile dark elevation="0" class="col-6" @click="filter.code = 'ebook'; search(true);">eBook</v-btn>
                                <v-btn :color="filter.code == 'book' ? 'primary' : 'grey'" :outlined="filter.code == 'book' ? false : true" x-large tile dark elevation="0" class="col-6" @click="filter.code = 'book'; search(true);">도서</v-btn>
                            </v-layout>
                        </div>
                    </div>
                </div>

                <div>
                    <v-data-table :items="orders" :headers="purchasesHeaders" disable-pagination disable-sort mobile-breakpoint="768" hide-default-footer class="v-data-table--sm purchase-table">
                        <template slot="item.orderNo" slot-scope="{item}">{{ item?.orderNo }}</template>
                        <template slot="item.product.name" slot-scope="{item}">{{ item?.product?.name }}</template>
                        <v-responsive slot="item.product" slot-scope="{item}">
                            <v-layout align-center>
                                <v-flex shrink><v-img :src="item?.product?.thumb" width="96" height="96" contain></v-img></v-flex>
                            </v-layout>
                        </v-responsive>
                        <template slot="item.option-addition" slot-scope="{item}">
                            <div v-if="item.product.type == 'option'">[{{ item.product.optionalNames.toString() }}] : {{ item.product.optionalValues.toString() }}</div>
                            <div v-if="item.product.type == 'addition'">[{{ item.product.additionalName.toString() }}] : {{ item.product.additionalValue.toString() }}</div>
                        </template>
                        <span slot="item.status" slot-scope="{item}">{{ item.status || item.order?.status }}</span>
                        <span slot="item.totalAmount" slot-scope="{item}">{{ item.totalAmount.format()}}원</span>
                        <span slot="item.shippingInfo" slot-scope="{item}">{{ item.shippingInfo.invoiceNumber }}</span>
                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD") }}</span>
                        <span slot="item.resend" slot-scope="{item}">
                            <v-icon v-if="item.issue?.pins?.length" small @click="resend(item)">mdi-message</v-icon>
                        </span>
                        <div slot="item.order.shippingAddress" slot-scope="{item}">
                            <div>[{{ item.order.shippingAddress.postcode }}] {{ item.order.shippingAddress.address1 }} {{ item.order.shippingAddress.address2 }}</div>
                        </div>
                        <template #[`item.detail`]="{item}">
                            <v-btn :to="`/mypage/shop/orders/${item._id}`" x-small color="primary" class="white--text px-6px">보기</v-btn>
                        </template>
                        <template #[`item.specification`]="{item}">
                            <v-btn @click="popup(item._id)" outlined x-small class="px-6px">출력</v-btn>
                        </template>
                        <template #[`item.cashbill`]="{item}">
                            <v-btn v-if="!item.cashbill.status && item.cashAmount !== 0 && checkCancel(item.purchases) && checkDay(item.createdAt)" outlined x-small class="px-6px" @click="cashbill(item)">신청</v-btn>
                            <!-- <v-btn v-if="item.cashbill.status && checkCancel(item.purchases)" outlined x-small class="px-6px" @click="printCashbill(item._id)">출력</v-btn> -->
                        </template>
                        <template #[`item.purchaseName`]="{item}">
                            <div>{{ item.purchases[0].product.name }} {{ item.purchases.length === 1 ? "" : `외 ${item.purchases.length - 1}건` }}</div>
                        </template>
                        <div slot="item.actions" slot-scope="{item}">
                            <v-btn v-if="(item.status == '주문완료' || item.status == '상품준비중' || item.status == '발송지연')" x-small outlined color="primary" :disabled="item.isClaim || item.giftStatus == '선물받기완료' || item.giftStatus == '선물포인트전환완료'" @click="claim(item, `cancel`)">취소요청</v-btn>
                            <v-btn v-if="(item.status != '주문완료' && item.status != '상품준비중' && item.status != '발송지연' && item.purchaseStatus != '구매확정완료' && item.status != '취소완료' && item.status) && !item.isClaim" x-small outlined color="primary" :disabled="item.isClaim" @click="claim(item, `return`)">반품요청</v-btn>
                            <!-- <v-btn v-if="!item.isClaim" x-small outlined color="primary" :disabled="item.isClaim" @click="claim(item, `exchange`)">교환요청</v-btn> -->
                            <v-btn v-if="(item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus == '구매확정완료') || (item.status == '반품반려' && item.isClaim && !item.review )" x-small outlined color="primary"  @click="review(item)">상품리뷰</v-btn>
                            <v-btn v-if="item.status == '배송완료' && !item.isClaim && !item.review && item.purchaseStatus != '구매확정완료'" x-small outlined color="primary" :disabled="item.isClaim" @click="confirmation(item)">구매확정</v-btn>
                        </div>
                        <div slot="null" slot-scope="{item}">
                            <v-btn x-small color="primary" class="white--text px-6px" :disabled="item.isClaim" @click="claim(item, `cancel`)">보기</v-btn>
                        </div>
                    </v-data-table>
                </div>
            </v-card>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="search(true)" />
            </div>

            <claim-dialog ref="claimDialog" @claim="search(false)" />
            <review-dialog ref="reviewDialog" @close="search(false)"/>
            <cashbill-dialog  ref="cashbillDialog" @close="search(false)" />
        </div>
    </component>
</template>
<script>
import api from "@/api";
import ClaimDialog from "@/components/client/mypage/claim-dialog.vue";
import ReviewDialog from "@/components/client/mypage/review-dialog.vue";
import cashbillDialog from "@/components/client/mypage/purchase/cashbill-dialog.vue"
import couriers from "@/assets/data/couriers.json";
export default {
    components: {
        ClaimDialog,
        ReviewDialog,
        cashbillDialog
    },
    data(){
        return {
            couriers,

            filter: {
                code: "ebook"
            },

            page: 1,
            pageCount: 0,
            limit: 10,

            orders : [],
            purchasesHeaders: [
                { text: "주문일자", value: "createdAt", align: "center", width: "9%", class: "", },
                { text: "주문번호", value: "orderNo", align: "center", width: "16%" },
                { text: "상품명", value: "purchaseName", align: "center", width: "18%" },
                { text: "결제금액", value: "totalAmount", align: "center", width: "10%" },
                { text: "상세보기", value: "detail", align: "center", width: "7%" },
                { text: "명세서", value: "specification", align: "center", width: "7%" },
                { text: "현금영수증",value: "cashbill", align: "center", width: "7%" }
            ]
        }
    },
    mounted(){
        if(this.logoff) this.$router.push(`/login`);
        this.init();
    },
    methods: {
        async init(){
            await this.search(false);
        },
        async resend(purchase){
            await api.v1.me.shop.purchases.resend(purchase);
            alert("재발송되었습니다");
        },
        popup(_order){
            if (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("iPhone") > -1) {
                alert("PC에서 지원하는 기능입니다.")
            } else {
                window.open(`/specification/${_order}`, '', 'width=650,height=600,scrollbars=yes');
            }
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, orders } = await api.v1.me.shop.orders.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter
            })
            this.orders = orders
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async claim(purchase, claimType){
            this.$refs.claimDialog.claimType = claimType;
            this.$refs.claimDialog.purchase = purchase;
            this.$refs.claimDialog.open();
        },
        review(purchase){
            this.$refs.reviewDialog.purchase = purchase;
            this.$refs.reviewDialog.open();
        },
        cashbill(order){
            this.$refs.cashbillDialog.order = order;
            this.$refs.cashbillDialog.open();
        },
        async confirmation(purchase){
            if(confirm('구매확정하시겠습니까?')){
                await api.v1.me.shop.purchases.put(purchase)
                alert('구매확정 되었습니다')
                await this.init()
            }
        },
        checkDay(createdAt) {
            let fiveDayAfterOrderAt = this.$dayjs(createdAt).add(5, "d").format("YYYY-MM-DD")
            let today = this.$dayjs().format("YYYY-MM-DD")
            if(fiveDayAfterOrderAt < today){
                return false;
            } else {
                return true;
            }
        }, 
        checkCancel(purchases) {
            let result = purchases.map(purchase => {
                if(purchase.status === "주문완료" || purchase.status === "상품준비중" || purchase.status === "발송지연" || purchase.status === "배송중" || purchase.status === "배송완료") {
                    return true
                }   
                return false
            })
            
            return !result.includes(false)
        }, 
        async printCashbill(_id) {
            if (navigator.userAgent.indexOf("Android") > -1 || navigator.userAgent.indexOf("iPhone") > -1) {
                alert("PC에서 지원하는 기능입니다.")
            } else {
                let { url } = await api.v1.me.shop.cashbill.print({ _id })
                window.open(url, '', 'width=800,height=640,scrollbars=yes');
            }
        }
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`) },

        logoff(){
            return !this.$store.state.accessToken;
        }
    }
}
</script>

<style scoped>
>>>.v-data-table--sm>.v-data-table__wrapper>table>tbody>tr>th, >>>.v-data-table--sm>.v-data-table__wrapper>table>tfoot>tr>th, >>>.v-data-table--sm>.v-data-table__wrapper>table>thead>tr>th, >>>.v-data-table--sm>.v-data-table__wrapper>table>tbody>tr>td, >>>.v-data-table--sm>.v-data-table__wrapper>table>tfoot>tr>td, >>>.v-data-table--sm>.v-data-table__wrapper>table>thead>tr>td{
    font-size:13px !important;
    padding:2px !important;
}
.v-data-table--sm .v-btn:not(.v-btn--round).v-size--x-small{
    min-width: auto;
    font-size: 13px;
    padding:0 4px;
}
</style>